import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const snippet = `{
  "mcpServers": {
    "rscircuit": {
      "url": "https://auth.pcbx.ai/mcp",
      "headers": { "Authorization": "Bearer <oauth-access-token>" }
    }
  }
}`;

export function McpHelp() {
  return (
    <div className="space-y-4">
      <p className="text-[13px] text-muted-foreground">
        MCP OAuth tokens are not session.token. Scopes: project:read, mind:check, review:write. Chat chrome
        still AI Elements. This cloud UI is Team Platform, not the local rscircuit workbench. Staging GitHub
        login is Better Auth on the workbench Worker; the MCP authorization server / portal is{" "}
        <a href="https://github.com/dwdwdw5163/rscircuit/pull/12" className="underline">
          PR #12
        </a>
        , not this identity path.
      </p>
      <Tabs defaultValue="cursor">
        <TabsList>
          <TabsTrigger value="cursor">Cursor</TabsTrigger>
          <TabsTrigger value="other">Other</TabsTrigger>
        </TabsList>
        <TabsContent value="cursor" className="mt-4">
          <Card>
            <CardHeader className="flex flex-row items-center justify-between">
              <CardTitle className="text-sm">mcp.json</CardTitle>
              <Button size="sm" variant="outline" onClick={() => navigator.clipboard.writeText(snippet)}>
                Copy
              </Button>
            </CardHeader>
            <CardContent>
              <pre className="overflow-auto rounded-[4px] bg-black p-3 font-mono text-xs">{snippet}</pre>
            </CardContent>
          </Card>
        </TabsContent>
        <TabsContent value="other" className="mt-4 text-sm text-muted-foreground">
          CIMD / MCP 2026-07-28. Resource https://auth.pcbx.ai/mcp. DCR off.
        </TabsContent>
      </Tabs>
    </div>
  );
}
